import React, { useContext, useEffect, useState } from "react";
import "../../Tabels/Tabels.css";
import search1 from "../../../Components/assets/icons/search.png";
import Table from "react-bootstrap/Table";
import Header from "../../Header/Header";
import { Context } from "../../../utils/context";
import { Toaster } from "react-hot-toast";
import ModalDelete from "../../common/ModelDelete";
import { DeletButton } from "../../common/Button";
import { Button } from "react-bootstrap";
import { formatDate, IDS } from "../../../utils/common";
import Pagination_Holder from "../../common/Pagination_Holder/Pagination_Holder";

// Add an IDS.CareerApplication entry and this switches over by itself
const PERM = IDS.CareerApplication || IDS.Customer;

const Tables = () => {
  const { getData, deleteData, ErrorNotify, Per_Page_Dropdown, isAllow, IMG_URL } = useContext(Context);

  const [data, setData] = useState([]);
  const [perPage, setperPage] = useState(5);
  const [onPageChange, setonPageChange] = useState(1);
  const [refresh, setRefresh] = useState(false);
  const [option, setOption] = useState();

  // filters
  const [search, setSearch] = useState("");
  const [searchCompany, setSearchCompany] = useState("");
  const [searchJobType, setSearchJobType] = useState("");
  const [searchShiftType, setSearchShiftType] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

  useEffect(() => {
    (async () => {
      const q = new URLSearchParams({
        page: onPageChange,
        per_page: perPage,
        term: search,
        searchCompany,
        searchJobType,
        searchShiftType,
        from,
        to,
      });
      const response = await getData(`/admin/career/career-applications?${q.toString()}`);
      setData(response);
      setOption(await Per_Page_Dropdown(response?.data?.total));
    })();
    // eslint-disable-next-line
  }, [perPage, onPageChange, refresh]);

  const applyFilters = () => {
    setonPageChange(1);
    setRefresh((r) => !r);
  };

  const resetFilters = () => {
    setSearch("");
    setSearchCompany("");
    setSearchJobType("");
    setSearchShiftType("");
    setFrom("");
    setTo("");
    setonPageChange(1);
    setRefresh((r) => !r);
  };

  // Delete
  const [del, setDel] = useState(null); // { id, name }
  const confirmDelete = async () => {
    const target = del;
    setDel(null);
    if (!target) return;
    await deleteData(`/admin/career/career-applications/${target.id}`);
    ErrorNotify(target.name);
    setRefresh((r) => !r);
  };

  const rows = data?.data?.data || [];
  const total = data?.data?.total || 0;
  const currentPage = data?.data?.current_page || 1;
  const size = Number(perPage) || 5;
  const showingFrom = total ? (currentPage - 1) * size + 1 : 0;
  const showingTo = Math.min(currentPage * size, total);

  const Filter = ({ label, value, set, type = "text", placeholder }) => (
    <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 mb-2">
      <div className="num">
        <label className="form-label">{label}</label>
        <input
          type={type}
          className="form-control"
          value={value}
          placeholder={placeholder}
          onChange={(e) => set(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && applyFilters()}
        />
      </div>
    </div>
  );

  return (
    <>
      <div className="main-advancedashboard">
        <Header title={"Career Applications"} link={"/admin/career/career-applications"} />
        <section className="AdvanceDashboard">
          <div className="col-lg-12 p-0">
            <div className="row MainRowsec me-0 ms-0">
              <section className="Tabels tab-radio tab-radio">
                <div className="">
                  <div className="row">
                    <div className="border-line mt-3"></div>
                    <div className="row mt-3">
                      <div className="col-12">
                        <div className="d-flex align-items-center mb-1">
                          <div className="show me-2">
                            <p className="show m-0">Show</p>
                          </div>
                          <div className="number me-2">
                            <select
                              className="form-select form-select-sm"
                              aria-label=".form-select-sm example"
                              onChange={(e) => {
                                setonPageChange(1);
                                setperPage(e.target.value);
                              }}
                            >
                              {option?.map((o) => (
                                <option key={o} value={o}>
                                  {o}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="entries">
                            <p className="show m-0">entries</p>
                          </div>
                          <div className="sowing ms-3 me-2">
                            <p className="show m-0">{`Showing ${showingFrom} to ${showingTo} of ${total} entries`}</p>
                          </div>
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="row align-items-start">
                          <Filter label="Position" value={search} set={setSearch} placeholder="Search position" />
                          <Filter label="Company Name" value={searchCompany} set={setSearchCompany} placeholder="Search company" />
                          <Filter label="Job Type" value={searchJobType} set={setSearchJobType} placeholder="Job type" />
                          <Filter label="Shift Type" value={searchShiftType} set={setSearchShiftType} placeholder="Shift type" />
                          <Filter label="Applied From" value={from} set={setFrom} type="date" />
                          <Filter label="Applied To" value={to} set={setTo} type="date" />

                          <div className="col-xxl-1 col-xl-2 col-lg-2 col-md-2 col-sm-6 col-12 mb-2">
                            <div className="Search">
                              <label className="form-label">Search</label>
                              <Button type="button" onClick={applyFilters} className="btn btn-search">
                                <img src={search1} className="search" alt="" />
                              </Button>
                            </div>
                          </div>
                          <div className="col-xxl-1 col-xl-2 col-lg-2 col-md-2 col-sm-6 col-12 mb-2">
                            <div className="Search-1">
                              <label className="form-label">Reset</label>
                              <div>
                                <button type="button" onClick={resetFilters} className="btn btn-reset">
                                  Reset
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="border-line mt-3"></div>
                  <div className="row mt-3">
                    <div className="data table-responsive">
                      <Table striped bordered hover responsive center>
                        <thead>
                          <tr>
                            <th className="sr">Sr. No.</th>
                            <th className="tax-name">Applicant</th>
                            <th className="tax-name">Position</th>
                            <th className="tax-name">Company</th>
                            <th className="tax-name">Location</th>
                            <th className="tax-name">Recruiter Email</th>
                            <th className="tax-name">Package</th>
                            <th className="tax-name">Applied On</th>
                            <th className="tax-name">Resume</th>
                            <th className="active">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {rows.map((d, index) => (
                            <tr key={d?.id ?? index}>
                              <td>{(onPageChange - 1) * size + index + 1}.</td>
                              <td className="width_dertails_name_div">{d?.name}</td>
                              <td>{d?.Career?.name}</td>
                              <td>{d?.Career?.company_name}</td>
                              <td>{d?.Career?.job_location}</td>
                              <td>{d?.Career?.recruiter_email}</td>
                              <td>
                                {d?.Career?.start_annual_package
                                  ? `${d.Career.start_annual_package} - ${d.Career.end_annual_package} per annum`
                                  : ""}
                              </td>
                              <td>{d?.createdAt ? formatDate(d.createdAt) : ""}</td>
                              <td>
                                {d?.resume ? (
                                  <a href={IMG_URL + d.resume} target="_blank" rel="noopener noreferrer">
                                    View resume
                                  </a>
                                ) : (
                                  ""
                                )}
                              </td>
                              <td>
                                <div className="d-flex">
                                  {isAllow?.includes(PERM.Delete) && (
                                    <DeletButton
                                      showDeleteRecord={(id, name) => setDel({ id, name })}
                                      id={d?.id}
                                      name={d?.name || d?.Career?.name}
                                    />
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                      {rows.length > 0 ? (
                        <Pagination_Holder
                          onPageChange={currentPage}
                          totalPages={data?.data?.total_pages}
                          handlePageChange={setonPageChange}
                        />
                      ) : (
                        <p className="no-datashow">Sorry, No Data Found</p>
                      )}
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>

      <ModalDelete show={!!del} handleDeleteRecord={confirmDelete} handleDeleteCancel={() => setDel(null)} />
      <Toaster position="top-right" />
    </>
  );
};

export default Tables;